import { TitleCasePipe } from '@angular/common';
import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
import { ConfirmationService, LazyLoadEvent, MessageService } from 'primeng/api';
import { Dropdown } from 'primeng/dropdown';
import { Table } from 'primeng/table';
import { environment } from 'src/environments/environment';
import { UserService } from '../../../services/user.service';
import { saveAs } from 'file-saver/src/FileSaver';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-partner-list',
    templateUrl: './userDeleteRequest.component.html',
    styleUrls: ['./userDeleteRequest.component.scss'],
    providers: [MessageService, ConfirmationService, TitleCasePipe]
})

export class UserDeleteRequestListComponent implements OnInit, OnDestroy {

    private destroy$ = new Subject<void>();
    searchBy: any[];
    searchby;
    searchbyreason;
    startDate: Date;
    endDate: Date;
    userDeletelist: any = [];
    totalRecords: 0;
    loading: boolean;
    paginationOption;
    Ammenity;
    downloadFlg: boolean;
    errorMessage = '';
    id: any;
    hideImage: boolean = false;
    ammentystatus: boolean = false;
    hidestatus: boolean = false
    errormessage = '';
    public hide: boolean = true;
    private lastTableLazyLoadEvent: LazyLoadEvent;
    username: string;
    userName;
    public reasonList: any = [];
    downloadUserList: any;
    @ViewChild("dt", { static: false }) public dt: Table;
    @ViewChild("pDropDownId", { static: false }) pDropDownId: Dropdown;
    selectedReason: any;

    constructor(private route: ActivatedRoute, private userService: UserService, private confirmationservice: ConfirmationService, private titlecasePipe: TitleCasePipe, private messageService: MessageService,) { }

    ngOnInit(): void {
        this.Ammenity = environment.amenitiesArray
        this.paginationOption = environment.pagination;
        this.id = this.route.snapshot.paramMap.get("id");
        this.downloadFlg = false;

        this.searchBy = [
            { label: 'Requested On', value: "created_at" },
        ];
        this.reasonList = [
            { id: 1, label: 'Not happy with us.' },
            { id: 2, label: 'Get another application.' },
            { id: 3, label: 'Not easy to use.' },
            { id: 4, label: 'Other' },
        ];
    }

    clear() {
        this.startDate = null;
        this.endDate = null;
        this.searchby = '';
        this.dt.filter('', 'userName', 'contains')
        this.dt.filter('', 'reason', 'contains');
        this.dt.filter('', 'email', 'contains');
        this.dt.filter('', 'mobileNumber', 'contains');

        this.dt.filter('', 'venue', 'dateIs');
        this.pDropDownId.clear(null);
        if (this.pDropDownId) {
            this.pDropDownId.value = null;
        }
    }
    reasonSelect(event) {
        if (event.value != null) {
            this.selectedReason = event.value.label;
        } else {
            this.selectedReason = null

        }
        this.loaduserDeleteRequestlist(this.lastTableLazyLoadEvent);
    }
    loaduserDeleteRequestlist(event: LazyLoadEvent) {
        this.lastTableLazyLoadEvent = event;

        var query="?";// = "?filterByUserId=" + this.id;
        var pagenumber = 1;
        var params = "";
        var rows;
        if (event.first != undefined && event.first == 0) {
            pagenumber = event.first + 1;
        } else if (event.first != undefined && event.first > 0) {
            pagenumber = (event.first / event.rows) + 1;
        } else {
            pagenumber = 1;
        }
        if (event.rows != undefined) {
            rows = event.rows;
        } else {
            rows = 10;
        }

        if (this.searchby != undefined && this.startDate != undefined && this.endDate != undefined) {
            params += "&filterByDate=" + this.searchby.value;
            params += "&filterByStartDate=" + moment(this.startDate).format("YYYY-MM-DD");
            params += "&filterByEndDate=" + moment(this.endDate).format("YYYY-MM-DD");

        }
        if (this.searchbyreason != null) {
            params += "&filterByReason=" + this.searchbyreason.label;

        }

        if (event.filters != undefined && event.filters["userName"] != undefined) {
            params += "&filterByName=" + event.filters["userName"].value;
        }
        if (event.filters != undefined && event.filters["email"] != undefined) {
            params += "&filterByEmail=" + event.filters["email"].value;
        }
        if (event.filters != undefined && event.filters["mobileNumber"] != undefined) {
            params += "&filterByPhoneNumber=" + event.filters["mobileNumber"].value;
        }
        if (event.filters != undefined && event.filters["reason"] != undefined) {
            params += "&filterByReason=" + event.filters["reason"].value;
        }

        // at the reason of download hide pagination option
        if (this.downloadFlg == false) {
            if (params != undefined && params != "") {
                query += "&pageSize=" + rows + "&pageNumber=" + pagenumber + params;
            } else {
                query += "&pageSize=" + rows + "&pageNumber=" + pagenumber;
            }
        } else {
            if (params != undefined && params != "") {
                query += params;
            }
        }

        if (event.sortField != undefined && event.sortOrder != undefined) {
            var orderBy = "";
            if (event.sortOrder == 1) {
                orderBy = "DESC";
            } else {
                orderBy = "ASC";
            }
            query += "&sortBy=" + event.sortField + "&orderBy=" + orderBy;
        }
        this.userService.getUserDeleteRequest(query).pipe(takeUntil(this.destroy$)).subscribe(
            data => {
                // this.username = data?.data?.items[0]?.userName;
                this.loading = false;
                this.userDeletelist = data.data.items;
                this.totalRecords = data.data.totalCount;


            },
            err => {
                this.errorMessage = err.error.message;
            }
        );



    }
    setDownloadFlag() {
        this.downloadFlg = false;
    }

    deleteUser(user) {
        console.log(user);
        this.confirmationservice.confirm({
            message: `
            <h4 style="margin:0;">Are you sure?</h4>
            <p style="margin-top:10px;">
                Are you sure you want to delete ${this.titlecasePipe.transform(user.fullName)} ?
            </p>
            `,
            acceptLabel: 'Confirm',
            rejectLabel: 'Cancel',

            
            //message: 'Are you sure you want to delete ' + (this.titlecasePipe.transform(user.fullName)) + '?',
            header: 'Confirm',
            icon: 'pi pi-exclamation-triangle', 
            accept: () => {
                var disableStatus;
                if (user.userDisable == false) {
                    disableStatus = true;
                } else {
                    disableStatus = false;
                }
                var userData = '{"disable":' + disableStatus + '}';
                this.userService.updateUser(user.userId, userData).pipe(takeUntil(this.destroy$)).subscribe(
                    data => {
                        this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'User Deleted', life: 3000 });
                        this.loaduserDeleteRequestlist(this.lastTableLazyLoadEvent);
                    },
                    err => {
                        this.errorMessage = err.error.message;
                    }
                );
            },
            reject: () => {
                //this.getUserDetails(user.id);
            }
        });
    }

    //use to add columns
    addColumns() {
        this.hide = false;

    }

    //use to remove columns
    removeColumns() {
        this.hide = true;
    }
    exportExcel() {
        this.downloadFlg = true;
        this.loaduserDeleteRequestlist(this.lastTableLazyLoadEvent);
        setTimeout(() => {
            this.downloadUserList = this.userDeletelist;
            var propertiesRemove = ['id','status','disable','userDisable','updated_at'];
            this.downloadUserList.forEach(function (item) {
                if (item.created_at != '') {
                    item['created_at'] = moment(item.created_at).format('DD-MM-YYYY');
                }                

                if (item.status) {
                    item['status'] = 'Active';
                } else {
                    item['status'] = 'In-Active';
                }
                
                propertiesRemove.forEach(function (prop) {
                    delete item[prop];
                });
            });
            import("xlsx").then(xlsx => {
                const worksheet = xlsx.utils.json_to_sheet(this.downloadUserList);
                const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
                const excelBuffer: any = xlsx.write(workbook, {
                    bookType: "xlsx",
                    type: "array"
                });
                this.saveAsExcelFile(excelBuffer, "Deleted_Player_List");
            });
            this.downloadFlg = false;
            this.loaduserDeleteRequestlist(this.lastTableLazyLoadEvent);

        }, 1000
        )
    }


    saveAsExcelFile(buffer: any, fileName: string): void {
        import("file-saver").then(FileSaver => {
            let EXCEL_TYPE =
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
            let EXCEL_EXTENSION = ".xlsx";
            const data: Blob = new Blob([buffer], {
                type: EXCEL_TYPE
            });
            let filename;
            filename = fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION;
            saveAs(data, filename);
        });
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
